export default "__VITE_ASSET__B$8CY7Vq__"